export const getBaseUrl = () => (location.pathname.includes('/mock') ? '/mock' : '/ks')
